import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  onBack?: () => void;
  showBack?: boolean;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, onBack, showBack = true }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="page-header">
      {showBack && (
        <button className="page-header-back-button" onClick={handleBack} aria-label="Назад">
          <img src="/chevron-back.png" alt="" width={24} height={24} />
        </button>
      )}
      <h1 className={`page-header-title ${!showBack ? 'page-header-title--no-back' : ''}`}>{title}</h1>
    </div>
  );
};

